/* eslint-disable */

import React, { useState } from "react";
import { useHistory } from "react-router";
import { UpCircleOutlined } from "@ant-design/icons";
import { Modal, Collapse, Row, Col } from "antd";
import Moment from "react-moment";
import { GrFormClose } from "react-icons/gr";
import { IoDocumentTextOutline } from "react-icons/io5";

import "./style.css";
import "../../App.css";

import DownloadCertifcate from "../../Screens/Certificates/DownLoadCertificate";
import UberCertificate from "../../Screens/Certificates/UberCertificate";
import UberCertificateScNcGe from "../../Screens/Certificates/UberCertificateScNcGe";
import TuroCertificate from "../../Screens/Certificates/TuroCertificate";
import HopeSkipDriveCertificate from "../../Screens/Certificates/HopeSkipDriveCertificate";

import Lyftcertificate from "../../Screens/Certificates/Lyftcertificate";
import LyftCertificateArizona from "../../Screens/Certificates/LyftCertificateArizona";
import LyftCertificateSouthCarolina from "../../Screens/Certificates/LyftCertificateSouthCarolina";
import LyftCertificateNevada from "../../Screens/Certificates/LyftCertificateNevada";
import LyftCertificateMichigan from "../../Screens/Certificates/LyftCertificateMichigan";
import LyftCertificateColorado from "../../Screens/Certificates/LyftCertificateColorado";

import CarIcon from "../../Assets/caricons.svg";
import { GetAroundCertificate } from "../../Screens";
import { resolveCertificateComponent } from "../../Screens/Certificates/resolveCertificate";
import { downloadUploadedCertificate } from "../../utils/downloadUploadedCertificate";

const ReviewedTileComponent = ({
  item,
  genExtra,
  handleNewCompany,
  handleVehicleDetails,
}) => {
  const { Panel } = Collapse;
  const history = useHistory();

  const [company, setCompany] = useState(false);
  const [companyModalVisible, setCompanyModalVisible] = useState(false);
  const [iscertificateLoading, setisCertificateLoading] = useState(false);
  const [certificateData, setCertificateData] = useState({
    id: "",
    companyId: "",
    companyName: "",
    templateId: "",
    url: "",
  });

  const inspectionData = {
    vehicleId: item?.Vehicle?.id,
    plateNumber: item?.Vehicle?.licensePlateNumber,
    state: item?.inspectionState,
  };

  const showModalCompany = () => {
    setCompanyModalVisible(true);
  };

  const handleOkCompany = () => {
    setCompanyModalVisible(false);
  };
  const handleCancelCompany = () => {
    setCompanyModalVisible(false);
    setCompany(false);
    setCertificateData({
      id: "",
      companyId: "",
      companyName: "",
      templateId: "",
      url: "",
    });
    window.location.reload();
  };

  const handleDownload = (items, id) => {
    setCompany(true);
    setCertificateData({
      id: id,
      companyId: items?.Company?.id,
      companyName: items?.Company?.name,
      templateId: items?.Company?.templateId,
      url: items?.certificateUrl,
    });
  };

  // After the user clicks the generated Download button, refresh the page so
  // the certificate modal closes automatically. Ignores clicks fired while the
  // PDF is still being prepared.
  const handleDownloadClickClose = (e) => {
    const btn = e.target.closest(".certificate-download-button");
    if (!btn || btn.classList.contains("is-loading")) return;
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const renderCertificate = () => {
    if (!company) return null;

    // Lyft (all states): if a certificate image was uploaded on the dashboard, download that
    // image instead of generating the PDF. Falls back to the PDF when no image was uploaded.
    if (
      certificateData?.companyName?.toLowerCase() === "lyft" &&
      certificateData?.url
    ) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="certificate-download-button"
            style={{ cursor: "pointer" }}
            onClick={() =>
              downloadUploadedCertificate(certificateData.url).then(() =>
                setTimeout(() => window.location.reload(), 1500)
              )
            }
          >
            Download vehicle report
          </div>
        </div>
      );
    }

    const CertificateComponent = resolveCertificateComponent(
      certificateData,
      item?.inspectionState
    );

    if (!CertificateComponent) return null;

    return (
      <div onClick={handleDownloadClickClose}>
        <CertificateComponent
          SetModal={setCompanyModalVisible}
          handleModal={handleCancelCompany}
          setLoading={setisCertificateLoading}
          isLoading={iscertificateLoading}
          companyId={certificateData?.companyId}
          id={certificateData?.id}
        />
      </div>
    );
  };

  // const handleVehicleDetails = (item) => {
  //   history.push(`/VehicleAfterReviewing/${item?.id}/${item?.vehicleId}`);
  // };

  // const handleRedirect = (item) => {
  //   window.location.href = `/vehicleinspection/${item?.id}/${item?.vehicleId}?lyftUser=${item.lyftInspection}`;
  // };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Collapse
        expandIconPosition="right"
        defaultActiveKey={["1"]}
        expandIcon={({ isActive }) => (
          <UpCircleOutlined
            style={
              isActive
                ? {
                    fontSize: 28,
                    color: "#FF7A00",
                    marginTop: 10,
                    marginRight: 2,
                  }
                : {
                    fontSize: 28,
                    color: "#FF7A00",
                    marginTop: 10,
                    marginRight: 2,
                  }
            }
            rotate={isActive ? 180 : 0}
          />
        )}
        className="submitted-tile"
      >
        <div className="submitted-tile-content">
          <div>
            <div className="submitted-tracking-id-text">License Plate No.</div>
            <div className="submitted-tracking-id">
              {item?.Vehicle?.licensePlateNumber}
              {/* {"Reviewed"} */}
            </div>
          </div>
          <div>
            <div className="submitted-date-created">Date Created</div>
            <div className="submitted-date">
              <Moment format="MM/DD/YYYY">{item?.createdAt}</Moment>
            </div>
          </div>
        </div>
        <div className="submitted-tile-tag">Reviewed</div>

        <Panel
          style={{ overflow: "hidden" }}
          header={
            <Row gutter={40}>
              <Col>
                <div className="reviewed-all-text"></div>
              </Col>
              <Col></Col>
            </Row>
          }
          key="1"
          extra={genExtra}
        >
          <div className="document-container">
            <IoDocumentTextOutline color="#1468BA" size={18} />
            <div className="document-text" onClick={() => showModalCompany()}>
              Download Certificate
            </div>
          </div>
          <div className="document-container">
            <img src={CarIcon} className="car-icon-style" />
            <div
              className="document-text"
              onClick={() => {
                history.push(`/selectCompany/${true}`, inspectionData);
              }}
            >
              Re-Inspect Car
            </div>
          </div>
          <div className="document-container">
            <img src={CarIcon} className="car-icon-style" />
            <div
              className="document-text"
              onClick={() => {
                handleVehicleDetails(item);
              }}
            >
              Car Details
            </div>
          </div>

          <div className="document-container">
            <img src={CarIcon} className="car-icon-style" />
            <div
              className="document-text"
              onClick={() => {
                handleNewCompany(item);
              }}
            >
              Add New Company
            </div>
          </div>
        </Panel>
      </Collapse>

      <Modal
        // style={{ width: '40px', height: '40px' }}
        title="Basic Modal"
        visible={companyModalVisible}
        onOk={handleOkCompany}
        onCancel={() => {
          handleCancelCompany();
        }}
      >
        <div className="companies-modal">
          <div className="modal-content-container">
            <div></div>
            <div className="option-text">Companies</div>
            <GrFormClose
              color="black"
              size={25}
              onClick={() => {
                handleCancelCompany();
              }}
            />
          </div>
          {item?.CompanyInspections?.map((items) => {
            return (
              <div className="modal-company-text" key={items?.id}>
                <div className="modal-links-text">{items?.Company?.name}</div>
                <input
                  className="checkbox-container"
                  type="radio"
                  name="name"
                  onClick={() => {
                    handleDownload(items, item?.id);
                  }}
                />
              </div>
            );
          })}
          {renderCertificate()}
        </div>
      </Modal>
    </div>
  );
};

export default ReviewedTileComponent;
